import i18n from '@speechki-frontend/core/i18n/i18n';
import { PodcastsPage, PodcastPage } from './views';

const routes = [
    {
        name: 'podcasts',
        path: '/podcasts',
        component: PodcastsPage,
        meta: {
            title: i18n.global.t('routes.podcasts'),
        },
    },
    {
        name: 'podcast-create',
        path: '/podcasts/create',
        component: PodcastPage,
    },
    {
        name: 'podcast',
        path: '/podcasts/:id',
        component: PodcastPage,
    },
];

export default routes;
